import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="removals"
export default class extends Controller {
  remove() {
    const parent = this.element.closest('.remove-on-button')
    if (parent) parent.remove()
  }
}
